export const getstarteds = [
  {
    number: 1,
    title: "GET_STARTED_TITLE_1",
    text: "GET_STARTED_TITLE_1_DESC",
  },
  {
    number: 2,
    title: "GET_STARTED_TITLE_2",
    text: "GET_STARTED_TITLE_2_DESC",
  },
  {
    number: 3,
    title: "GET_STARTED_TITLE_3",
    text: "GET_STARTED_TITLE_3_DESC",
  },
  {
    number: 4,
    title: "GET_STARTED_TITLE_4",
    text: "GET_STARTED_TITLE_4_DESC",
  },
{
  number: 5,
  title: "GET_STARTED_TITLE_5",
  text: "GET_STARTED_TITLE_5_DESC",
  listItems: [
    "GET_STARTED_LIST_1",
    "GET_STARTED_LIST_2",
    "GET_STARTED_LIST_3"
  ]
}
];
